import React from "react"

// import Auth from "auth";
// import { API } from "API"
import { APIPost, APIGet } from "services/APIRequest"
import { arrayObject } from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Configs from "services/ConfigHost"
import Auth from "auth"
import { thaiBath } from "helpers/ConvertFormat"
import { ErrorsCallback, SuccessCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsProjectUpdate } from "store/actions"

import * as Alert from "alertService"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons
import AddCircleIcon from "@material-ui/icons/AddCircle"
import EditIcon from "@material-ui/icons/Edit"
import CloudUploadIcon from "@material-ui/icons/CloudUpload"
import ClearAllIcon from '@material-ui/icons/ClearAll';
import FilterListIcon from "@material-ui/icons/FilterList"
import Radio from "@material-ui/core/Radio";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
// core components 
import ReactTable from "react-table"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import CustomInput from "components/CustomInput/CustomInput"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import FileConfigUploadFileLeadCustomer from "components/CustomUpload/FileConfigUploadFileLeadCustomer"
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Datetime from "react-datetime";
import InputLabel from "@material-ui/core/InputLabel";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "30px"
  }
}
class ProjectCreateAndEditManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dataList: [],

      _id: null,
      filePath: "",
      send_sms_date: null,
      sms_expired_date: null,
      originalFileName: "",
      description: "",
      rowCurrentData: {},

      selectedImportCondition: "c0",
      currentQuarter: 1,
      quarterNumber: [
        {
          name: "ไตรมาสที่ 1",
          value: 1
        },
        {
          name: "ไตรมาสที่ 2",
          value: 2
        },
        {
          name: "ไตรมาสที่ 3",
          value: 3
        },
        {
          name: "ไตรมาสที่ 4",
          value: 4
        }
      ]
    }
  }
  // componentWillUpdate(nextProps, nextState) {
  // if(nextProps.currentData && nextProps.currentData !== nextState.rowCurrentData){
  //   this.setState({
  //     rowCurrentData: nextProps.currentData,
  //     _id:nextProps.currentData._id, 
  //     description: nextProps.currentData.description,
  //   })
  // }else if(nextProps.currentData === null && this.state._id !== null){
  //   this.setState({
  //     rowCurrentData: {},
  //     _id:null, 
  //     name: ""
  //   })
  // }
  // }
  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }
  handleSendToPreview = () => {
    if (this.state.description === "") {
      ErrorsCallback("ต้องการข้อมูล : ชื่อข้อมูล")
    } else if (this.state.filePath === "") {
      ErrorsCallback("ต้องการข้อมูล : ไฟล์ข้อมูล Excel")
    } else {
      Alert.Loading(true)
      const dataToSend = {
        setting_id: this.state._id,
        filePath: this.state.filePath,
        fileName: this.state.originalFileName,
        description: this.state.description,
        selectedImportCondition: this.state.selectedImportCondition
      }
      APIPost(UrlServer.URL_POST_IMPORT_EXCEL_LEAD_PREVIEW, dataToSend, (datas) => {
        const setting_id = datas.datas.length > 0 ? datas.datas[0].lead_setting_id : ""
        SuccessCallback(datas.message + " : " + setting_id, null, () => {
          this.setState({
            _id: setting_id,
            dataList: this.renderListData(datas.datas)
          }, () => {
            Alert.LoadingClose()
          })
        })
      })
    }
  }
  handleApproveLead = () => {
    if (!this.state.send_sms_date) {
      ErrorsCallback("ต้องการข้อมูล : วันที่ส่ง SMS")
    } else if (!this.state.sms_expired_date) {
      ErrorsCallback("ต้องการข้อมูล : วันที่ SMS หมดอายุ")
    } else {
      Alert.Loading(true)
      const dataToSend = {
        lead_setting_id: this.state._id,
        send_sms_date: this.state.send_sms_date,
        sms_expired_date: this.state.sms_expired_date,
        quarter_number: this.state.currentQuarter,
        // send_sms_date:new Date(new Date(this.state.send_sms_date).getTime()+25200000).toISOString(),
        // sms_expired_date:new Date(new Date(this.state.sms_expired_date).getTime()+25200000).toISOString(),
      }
      APIPost(UrlServer.URL_POST_IMPORT_EXCEL_LEAD_CONFIRM_IMPORT_LEAD, dataToSend, (datas) => {
        SuccessCallback(datas.message, null, () => {
          this.setState({
            _id: null,
            description: "",
            filePath: "",
            originalFileName: "",
            dataList: []
          }, () => {
            // this.props.callbacksetTabIndex(0)
            Alert.Loading(true)
            window.location.reload();
          });
        })
      })
    }
  }
  renderListData = data => {
    return data.map((CData, key) => {
      return {
        no: (key + 1),
        first_name: CData.first_name,
        last_name: CData.last_name,
        tel: CData.tel,
        data_duplicate_count: CData.data_duplicate_count,
      }
    })
  }
  callbackUploadedUrl = (filename, originalFileName) => {
    this.setState({
      filePath: Configs.FILE_PATH + filename,
      originalFileName: originalFileName
    }, () => {
      Alert.LoadingClose()
    })
  }
  handleChangeSelected = (event) => {
    this.setState({ selectedImportCondition: event.target.value });
  }
  newUpload = () => {
    Alert.QuestionCallback("คุณต้องการอัพโหลดไฟล์ใหม่ใช่หรือไม่?", "red", () => {
      this.setState({
        _id: null,
        filePath: "",
        originalFileName: "",
        dataList: []
      });
    })
  }
  handleDateTimeChange = (name, date) => {
    const dateF = new Date(date).toISOString()
    this.setState({
      [name]: dateF
    })
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  {
                    ((this.state._id) ?
                      <EditIcon />
                      :
                      <AddCircleIcon />
                    )
                  }
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  {
                    ((this.state._id) ?
                      "ข้อมูล Lead Setting ID:" + this.state._id
                      :
                      "ฟอร์มการนำเข้า Lead"
                    )
                  }
                </h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        ชื่อข้อมูล
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={10} lg={10}>
                      <CustomInput
                        error={this.state.description ? false : true}
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.description,
                          placeholder: "From the one 01-01-2020 : 1000 datas",
                          onChange: this.handleChangeState("description")
                        }}
                        helpText={this.state.description ? "" : (<span className="txt-c-r">* จำเป็นต้องใส่</span>)}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2 date-a22334"}>
                        วันที่ส่ง SMS
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={10} lg={10} className={"m-b-2"}>
                      <FormControl fullWidth>
                        <Datetime
                          timeFormat={false}
                          onChange={e => this.handleDateTimeChange("send_sms_date", e)}
                          inputProps={{
                            readOnly: true,
                            placeholder: "กดเลือกวันที่ตรงนี้",
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2 date-a22334"}>
                        วันที่ SMS หมดอายุ
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={10} lg={10} className={"m-b-2"}>
                      <FormControl fullWidth>
                        <Datetime
                          timeFormat={false}
                          onChange={e => this.handleDateTimeChange("sms_expired_date", e)}
                          inputProps={{
                            readOnly: true,
                            placeholder: "กดเลือกวันที่ตรงนี้",
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2 date-a22334"}>
                        เลือก ไตรมาส
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={10} lg={10} className={"Select-8-11-63"}>
                      <Select
                        value={this.state.currentQuarter}
                        listData={this.state.quarterNumber}
                        onChange={this.handleChangeState("currentQuarter")}
                      />
                    </GridItem>

                  </GridContainer>
                  {(this.state.filePath == "") ?
                    <GridContainer>
                      <GridItem xs={12}>
                        <h4>เงื่อนไขรูปแบบไฟล์ที่อัพ</h4>
                        <ul>
                          <li className="list-format-xlsx">จะต้องเป็นไฟล์ ".xlsx"</li>
                          <li className="list-format-xlsx">Sheet หลักจะต้องชื่อ "leads"</li>
                          <li className="list-format-xlsx">Row 1 จะต้องเป็นชื่อ field</li>
                          <li className="list-format-xlsx">ในไฟล์จะต้อง field ("dealer_code","first_name","last_name","tel")</li>
                        </ul>
                      </GridItem>
                      <GridItem xs={12}>
                        <FileConfigUploadFileLeadCustomer
                          lockFileType=".xlsx"
                          FilePath={this.state.filePath}
                          CallbackUploadedUrl={this.callbackUploadedUrl}
                        />
                      </GridItem>
                    </GridContainer>
                    :
                    <div>
                      <span className="img-fw-txt m-l-4 txt-c-bu can-click">{this.state.filePath ? "ชื่อไฟล์ที่อัพโหลด คือ " + this.state.originalFileName + " , ลิ้งค์ที่อยู่ไฟล์ที่อัพโหลดแล้ว คือ " + this.state.filePath : "ยังไม่มีการเลือกอัพไฟล์"}</span>
                      <Button
                        round
                        color="danger"
                        className={classes.mt4}
                        onClick={() => this.newUpload()}
                      >
                        <ClearAllIcon className={classes.icons} />
                        ต้องการอัพไฟล์ใหม่
                      </Button>
                    </div>
                  }
                  <hr />
                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12}>
                      <FormControl component="fieldset" className={classes.formControl} disabled={this.state.dataList.length > 0 ? true : false}>
                        {/* <FormLabel component="legend">เงื่อนใขการนำข้อมมูลเข้าระบบ</FormLabel> */}
                        <h4>เงื่อนใขการนำข้อมมูลเข้าระบบ</h4>
                        <div
                          className={
                            classes.checkboxAndRadio +
                            " " +
                            classes.checkboxAndRadioHorizontal
                          }
                        >
                          <FormControlLabel
                            control={
                              <Radio
                                checked={this.state.selectedImportCondition === "c1"}
                                onChange={this.handleChangeSelected}
                                value="c1"
                                name="import_condition"
                                icon={
                                  <FiberManualRecord
                                    className={classes.radioUnchecked}
                                  />
                                }
                                checkedIcon={
                                  <FiberManualRecord
                                    className={classes.radioChecked}
                                  />
                                }
                                classes={{
                                  checked: classes.radio
                                }}
                              />
                            }
                            classes={{
                              label: classes.label
                            }}
                            label={<span className={(this.state.selectedImportCondition === "c1") ? "txt-c-b2" : ""}>ตรวจสอบข้อมูล "first name" + "last name" + "Tel" ห้ามซ้ำ</span>}
                          />
                        </div>
                        <div
                          className={
                            classes.checkboxAndRadio +
                            " " +
                            classes.checkboxAndRadioHorizontal
                          }
                        >
                          <FormControlLabel
                            control={
                              <Radio
                                checked={this.state.selectedImportCondition === "c2"}
                                onChange={this.handleChangeSelected}
                                value="c2"
                                name="import_condition"
                                icon={
                                  <FiberManualRecord
                                    className={classes.radioUnchecked}
                                  />
                                }
                                checkedIcon={
                                  <FiberManualRecord
                                    className={classes.radioChecked}
                                  />
                                }
                                classes={{
                                  checked: classes.radio
                                }}
                              />
                            }
                            classes={{
                              label: classes.label
                            }}
                            label={<span className={(this.state.selectedImportCondition === "c2") ? "txt-c-b2" : ""}>ตรวจสอบข้อมูล "first name" + "last name" ห้ามซ้ำแต่ "Tel" ซ้ำได้</span>}
                          />
                        </div>
                        <div
                          className={
                            classes.checkboxAndRadio +
                            " " +
                            classes.checkboxAndRadioHorizontal
                          }
                        >
                          <FormControlLabel
                            control={
                              <Radio
                                checked={this.state.selectedImportCondition === "c3"}
                                onChange={this.handleChangeSelected}
                                value="c3"
                                name="import_condition"
                                icon={
                                  <FiberManualRecord
                                    className={classes.radioUnchecked}
                                  />
                                }
                                checkedIcon={
                                  <FiberManualRecord
                                    className={classes.radioChecked}
                                  />
                                }
                                classes={{
                                  checked: classes.radio
                                }}
                              />
                            }
                            classes={{
                              label: classes.label
                            }}
                            label={<span className={(this.state.selectedImportCondition === "c3") ? "txt-c-b2" : ""}>ตรวจสอบข้อมูล "Tel" ห้ามซ้ำแต่ "first name" + "last name" ซ้ำได้</span>}
                          />
                        </div>
                        <div
                          className={
                            classes.checkboxAndRadio +
                            " " +
                            classes.checkboxAndRadioHorizontal
                          }
                        >
                          <FormControlLabel
                            control={
                              <Radio
                                checked={this.state.selectedImportCondition === "c0"}
                                onChange={this.handleChangeSelected}
                                value="c0"
                                name="import_condition"
                                icon={
                                  <FiberManualRecord
                                    className={classes.radioUnchecked}
                                  />
                                }
                                checkedIcon={
                                  <FiberManualRecord
                                    className={classes.radioChecked}
                                  />
                                }
                                classes={{
                                  checked: classes.radio
                                }}
                              />
                            }
                            classes={{
                              label: classes.label
                            }}
                            label={<span className={(this.state.selectedImportCondition === "c0") ? "txt-c-b2" : ""}>ไม่ตรวจสอบ นำเข้าทั้งหมด</span>}
                          />
                        </div>
                        <FormHelperText>เลือกข้อที่ต้องการเพิ่มการกรองข้อมูลเข้าสู่ระบบ // ถ้าต้องการเงื่อนใขเพิ่มโปรดติดต่อ Developer</FormHelperText>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12}>
                      <Button
                        round
                        color="warning"
                        className={classes.mt4}
                        onClick={this.handleSendToPreview}
                      >
                        <FilterListIcon className={classes.icons} />
                        ประมวลผลไฟล์
                      </Button>
                      <span className="description-label">
                        กดปุ่มนี้เมื่อต้องการให้ระบบกรองข้อมูลออกมาแสดงก่อนบันทึกเข้าสู่การใช้งาน<br />
                        <FormHelperText>เวลาในการกรองข้อมูลขึ้นอยู่กันจะนวนข้อมูล</FormHelperText>
                      </span>

                    </GridItem>
                  </GridContainer>
                  <hr />
                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12}>
                      <span>จำนวน {thaiBath(this.state.dataList.length, false)} รายการ</span>
                      {
                        (this.state.dataList.length > 0) ?
                          <div>
                            <Button
                              round
                              color="success"
                              className={classes.mt4}
                              onClick={(e) => this.handleApproveLead()}
                            >
                              <CheckCircleIcon className={classes.icons} />
                              ยืนยันรายการทั้งหมดที่แสดง
                            </Button>
                          </div>
                          : ""
                      }
                      <ReactTable
                        data={this.state.dataList}
                        filterable
                        columns={[
                          {
                            Header: "No.",
                            accessor: "no",
                            width: 70
                          },
                          {
                            Header: "First Name",
                            accessor: "first_name"
                          },
                          {
                            Header: "Last Name",
                            accessor: "last_name"
                          },
                          {
                            Header: "Tel.No",
                            accessor: "tel"
                          },
                          {
                            Header: "Duplicate Count",
                            accessor: "data_duplicate_count",
                          }
                        ]}
                        defaultPageSize={10}
                        showPaginationTop
                        showPaginationBottom={false}
                        className="-striped -highlight"
                      />
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}
function mapStateToProps({ listsProject }) {
  return {
    // listsProject: listsProject
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    {
      // listsProjectUpdate 
    }
  )
)(ProjectCreateAndEditManagement)
